import { Container } from '@mantine/core'
import type { MetaFunction } from '@remix-run/node'
import { generateMetaDescriptor } from '~/core/shared/utils/misc'

export const meta: MetaFunction = (meta) =>
  generateMetaDescriptor(meta, { pageTitle: '企業様お問い合わせ' })

export const handle = {
  breadcrumb: () => {
    return [
      {
        id: 'contact-company',
        title: '企業様向けお問い合わせ',
      },
    ]
  },
}

export default function ContactCompany() {
  return (
    <Container>
      <iframe
        title='問い合わせ'
        src='https://airtable.com/embed/appzBvR0KuOV7FQeX/pagAw1rrmm9kdVH0W/form'
        width='100%'
        height='1000'
        style={{ background: 'transparent', border: '0' }}
      />
    </Container>
  )
}
